'use strict';

function arrayWrap(obj) {
  var arr = [];
  arr.push(obj);
  return arr;
}

module.exports = arrayWrap;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/internal/arrayWrap.js
// module id = 429
// module chunks = 0